function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(248, 247, 241)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'negro-negro': 'rgb(0, 0, 0)','moca': 'rgb(170, 132, 132)','beige': 'rgb(243, 219, 195)','nude': 'rgb(255, 222, 173)','blanco': 'rgb(255, 255, 255)','negro': 'rgb(0, 0, 0)','miel': 'rgb(164, 113, 37)','verde-olivo': 'rgb(128, 128, 0)','chocolate': 'rgb(88, 66, 45)','tawpe': 'rgb(199, 169, 119)','blanco-talco': 'rgb(248, 248, 255)','taupe': 'rgb(181, 164, 154)','dorada': 'rgb(201, 168, 64)','mocca': 'rgb(107, 79, 58)','arena': 'rgb(212, 188, 140)','capuchino': 'rgb(123, 92, 62)','negra': 'rgb(0, 0, 0)','talco': 'rgb(248, 248, 255)','amaretto': 'rgb(192, 120, 80)','arequipe': 'rgb(212, 165, 122)','tabaco': 'rgb(107, 66, 38)','negra': 'rgb(26, 26, 26)','negro-x-negro': 'rgb(38, 38, 38)','oro-rosa': 'rgb(183, 110, 121)','vaca-miel': 'rgb(201, 160, 99)','almendra': 'rgb(200, 162, 122)','talco': 'rgb(237, 230, 218)','avellana': 'rgb(160, 113, 74)','mani': 'rgb(198, 156, 109)','nucita': 'rgb(138, 90, 68)',};

    this.images = {'negro-blanco': 'url("//aleli.co/cdn/shop/files/negro_blan_120x.png?v=17780798582227311113")','jaguar': 'url("//aleli.co/cdn/shop/files/Jaguar_120x.jpg?v=2352526772927266648")','piton': 'url("//aleli.co/cdn/shop/files/Piton_120x.jpg?v=14019165566957333855")','oro-rosa': 'url("//aleli.co/cdn/shop/files/oro_rosa_120x.jpg?v=6401569785635839828")','animal-print': 'url("//aleli.co/cdn/shop/files/animal_120x.jpg?v=3714323690809732659")','dorado': 'url("//aleli.co/cdn/shop/files/dorado_120x.webp?v=2034124101809244506")','puma': 'url("//aleli.co/cdn/shop/files/puma_120x.jpg?v=1519593592293911604")','miel-vaca': 'url("//aleli.co/cdn/shop/files/vaca_miel_120x.jpg?v=8523566087555712994")','oro-vaca': 'url("//aleli.co/cdn/shop/files/Oro_Vaca_120x.jpg?v=10136497998568667224")','leopardo': 'url("//aleli.co/cdn/shop/files/LEOPARDO_120x.jpg?v=2696865201256004067")','leopardo-miel': 'url("//aleli.co/cdn/shop/files/Leopardo_Miel_120x.avif?v=1311790865472077000")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
